import { get } from './api-service';

const routes = {
  base: 'statuses',
};

export const getStatuses = async filters => {
  return await get(`${routes.base}${filters}`);
}
